<template>
  <div class="rvr-textarea">
    <textarea
        :id="`textarea-${name}`"
        :name="name"
        v-model="internalValue"
    />
  </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  name: "TextArea",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const internalValue = ref(props.modelValue);

    watch(internalValue, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      internalValue.value = newValue;
    });

    return { internalValue };
  },
};
</script>

<style scoped>

.rvr-textarea textarea {
  border: 1px solid #e9e9e9;
  background-color: #f8f9fa;
  border-radius: 10px;
  width: 70%;
  height: 100px;
  padding: 5px;
  box-sizing: border-box;
  outline: none;
  font-size: 1em;
}

.rvr-textarea textarea:focus-within {
  outline: auto 2px Highlight;
  outline: 5px auto -webkit-focus-ring-color;
}
@media (max-width: 768px) {
  .rvr-textarea textarea {
    width: 100%;
  }
}
</style>
